import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserStore } from '../../store/user/user.store';
import { ProviderService } from '../../services/provider/provider.service';
import { firstValueFrom, map } from 'rxjs';
import { providerRouter } from './provider-onboarding-steps/helper/provider-router.helper';

export const providerOnboardingAccessGuard: CanActivateFn = async (route, state) => {
  const router = inject(Router)
  const userStore = inject(UserStore)
  const providerService = inject(ProviderService)

  if (Number(userStore.id()) <= 0) {
    try {
      const provider = await firstValueFrom(
        providerService.getActiveProvider().pipe(
          map((response: any) => response),
        )
      )

      userStore.setParams({
        id: provider?.id ?? 0,
        active: provider?.active ?? false,
        clinic_id: provider?.clinic_id ?? 0,
        provider_id: provider?.provider_id ?? provider?.id ?? 0,
        onboarding_status: provider?.onboarding_status ?? 0
      })
    } catch(err) {
      console.error('Provider onboarding access guard failed:', err)
      return router.createUrlTree(['/login']);
    }
  }

  if(userStore.active()) {
    return router.createUrlTree(['/profile']);
  }

  const expectedUrl = providerRouter(userStore.onboarding_status());

  if (state.url === expectedUrl || state.url.startsWith(`${expectedUrl}?`)) {
    return true;
  }

  return router.createUrlTree([expectedUrl]);
};
